import PropTypes from "prop-types"
import Button from "components/Button"
import * as css from "./NewsletterSection.module.css"
import Section from "components/Layout/Section"
import SectionHeader from "components/Layout/SectionHeader"

function NewsletterSection({
  heading,
  description,
  darkTheme: inverted,
  ctaButton,
}) {
  return (
    <Section className={css.section} inverted={inverted} padding="heavy">
      <SectionHeader
        title={heading}
        subtitle={description}
        size="large"
        centered
        cta={
          ctaButton && (
            <Button
              className={css.cta}
              color={ctaButton.color}
              href={ctaButton.url}
              rounded={ctaButton.roundedCorner}
              trackClick={ctaButton.trackingName}
              large
            >
              {ctaButton.buttonLabel}
            </Button>
          )
        }
      />
    </Section>
  )
}

NewsletterSection.propTypes = {
  heading: PropTypes.string.isRequired,
  darkTheme: PropTypes.bool,
  ctaButton: PropTypes.shape({
    buttonLabel: PropTypes.string.isRequired,
    trackingName: PropTypes.string,
    url: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    roundedCorner: PropTypes.bool,
  }).isRequired,
}

export default NewsletterSection
